import { useState } from "react";
import { useGetProductCategoryList } from "../../../../hooks/api/queries";

export const useCategoryGroup = () => {
  const [isCreateCategory, setIsCreateCategory] = useState(false);
  const { data: categories, isLoading: isLoadingCategories } =
    useGetProductCategoryList();

  return {
    categories,
    isLoading: isLoadingCategories,
    isCreateCategory,
    setIsCreateCategory,
  };
};
